// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1_eFF"};


//////////////////
// WEBPACK FOOTER
// ./components/Container/index.scss
// module id = sQhb
// module chunks = 0